import { STextIcon } from './TextIcon.styles';
import { TextIconProps } from './TextIcon.types';

export const TextIcon = ({ ...props }: TextIconProps) => {
  return <STextIcon {...props} />;
};
